import { View } from 'components/View'
import ExerciseVariations from 'pages/Exercise/components/Variations'
import React from 'react'
import LazyLoad from 'react-lazyload'
import ExerciseDetails from 'pages/Exercise/components/Details/index.js'
import ExerciseContentMuscles from 'pages/Exercise/components/Content/components/Muscles/index.js'
import ExerciseContentEquipment from 'pages/Exercise/components/Content/components/Equipment/index.js'
import ExerciseContentType from 'pages/Exercise/components/Content/components/Type/index.js'
import ExerciseContentRepsOrTimeRecommendation from 'pages/Exercise/components/Content/components/RepsOrTimeRecommendation/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import { ExerciseContentLevel } from 'pages/Exercise/components/Content/components/Level/index.js'

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export default function ExerciseContent (props) {
  const {
    exerciseId,
    exerciseName,
    equipment,
    muscles,
    level
  } = props
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  return (
    <>
      <View>
        <View mx={isSmallScreen ? 1.5 : 0}>
          <ExerciseContentMuscles {...props} />
        </View>

        {
          !!level && (
            <View mx={isSmallScreen ? 1.5 : 0}>
              <ExerciseContentLevel {...props} />
            </View>
          )
        }

        <View mx={isSmallScreen ? 1.5 : 0}>
          <ExerciseDetails id={exerciseId} />
          <ExerciseContentEquipment {...props} />
          <ExerciseContentType {...props} />
          <ExerciseContentRepsOrTimeRecommendation {...props} />
        </View>

        <LazyLoad>
          <ExerciseVariations
            exerciseId={exerciseId}
            muscles={muscles}
            equipment={equipment}
            exerciseName={exerciseName}
          />
        </LazyLoad>
      </View>
    </>
  )
}
